<template>
  <div class="conBG">
    <ul class="menuList">
      <li
        v-for="(item,index) in list"
        :key="item.id"
        :class="{'active':navIndex==index}"
        @click="navIndex=index; to(item)"
      >
        {{item.name}}</li>
      <div style="clear:both;"></div>
    </ul>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      navIndex: 0,
      list: [
        // {
        //       id: 'projectinfo',
        //       name: '参建单位管理'
        //   },
        {
          id: 'unitdepart',
          name: '部门管理'
        },
        {
          id: 'unitrole',
          name: '角色管理'
        },
        {
          id: 'unitpreson',
          name: '人员管理'
        }
      ],
    }
  },
  methods: {
    to(v) {
      this.$router.push({
        name: v.id
      })
    }
  }
}
</script>

<style>
</style>